import { useState } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { Close } from '../../../icons';
import { cx } from '../../../utils/cx';

const infoCardVariants = cva(
  'relative flex w-full items-start gap-3 rounded-lg border p-4 text-sm',
  {
    variants: {
      severity: {
        info: 'border-blue-200 bg-blue-50 text-blue-700 [&>svg]:text-blue-700',
        warning:
          'border-amber-200 bg-amber-50 text-amber-700 [&>svg]:text-amber-700',
        error: 'border-red-200 bg-red-50 text-red-700 [&>svg]:text-red-700',
        success:
          'border-green-200 bg-green-50 text-green-700 [&>svg]:text-green-700'
      }
    },
    defaultVariants: {
      severity: 'info'
    }
  }
);

export interface InfoCardProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof infoCardVariants> {
  onDismiss?: () => void;
  dismissable?: boolean;
}

export function InfoCard({
  className,
  children,
  severity = 'info',
  dismissable,
  onDismiss,
  ...props
}: InfoCardProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={cx(infoCardVariants({ severity }), className)} {...props}>
      <div className="flex-1">{children}</div>
      {dismissable && (
        <button
          className="ml-auto -mr-1 -mt-1 rounded-md p-1 opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2"
          aria-label="dismiss"
          onClick={() => {
            setIsVisible(false);
            onDismiss?.();
          }}
        >
          <Close className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
